export interface CustomerDeclaredInformation {
    /** Customer declared information id. */
    id: number;
    /** Customer declared information death status. */
    is_dead: boolean | null;
    /** Customer declared information weight. */
    weight: number | null;
    /** Customer declared information height. */
    height: number | null;
    /** Customer declared information week of amenorrhoea. */
    amenorrhoea: number | null;
    /** Customer declared information breastfeeding status. */
    breast_feeding: BreastFeedingStatus | null;
    /** Customer declared information breastfeeding date. */
    breast_feeding_date: string | null;
    /** Customer declared information hepatic status. */
    hepatic: HepaticStatus | null;
    /** Customer declared information id. */
    dfg: number | null;
    /** Customer declared information smoking status. */
    smoking?: SmokingStatus | null;
}

export enum BreastFeedingStatus {
    NONE = 'NONE',
    LESS_THAN_ONE_MONTH = 'LESS_THAN_ONE_MONTH',
    MORE_THAN_ONE_MONTH = 'MORE_THAN_ONE_MONTH',
    ALL = 'ALL',
}

export enum HepaticStatus {
    NONE = 'NONE',
    MODERATE = 'MODERATE',
    SEVERE = 'SEVERE',
}

export enum SmokingStatus {
    SMOKER = 'SMOKER',
    NON_SMOKER = 'NON_SMOKER',
    OCCASIONAL_SMOKER = 'OCCASIONAL_SMOKER',
}

export interface BeneficiaryDeclaredInformation {
    height: number | null;
    weight: number | null;
    blood_group: string | null;
    is_dead: boolean | null;
    created_at: string;
    updated_at: string;
}
